"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenIcon = void 0;
const react_1 = __importDefault(require("react"));
const icons_1 = require("./icons");
const TokenIcon = ({ scale = 1, symbol }) => {
    switch (symbol === null || symbol === void 0 ? void 0 : symbol.toLowerCase()) {
        case "busd":
            return react_1.default.createElement(icons_1.BUSDIcon, { scale: scale });
        case "mc":
            return react_1.default.createElement(icons_1.MCIcon, { scale: scale });
        default:
            return null;
    }
};
exports.TokenIcon = TokenIcon;
